<template>
  <!-- <div class="auth-app" :style="getHeight"> -->
  <div class="auth-app" :class="isSafari?'safari-class':'normal-class'">
    <mt-header fixed title="身份驗證-全球付"></mt-header>
    <div style="height:45px;"></div>
    <div class="account">參考編號：{{order_no}}</div>
    <div class="input-box">
      <div class="box-1" v-if="status !== '2' && type === 'entity'">
        <input
          class="cvc2-input"
          v-model="activateCode"
          type="text"
          placeholder="請輸入任意一張卡片背面條碼下方的激活碼"
          maxlength="16"
        />
      </div>
      <div class="box-1 flexa">
        <div class="mobile-picker flexa" @click="isPickerShow = true">
          <span style="width: 80px;">{{mobileShow}}</span>
          <van-icon name="arrow-down" style="padding-left: 6px;" />
        </div>
        <input type="number" class="mobile-input" placeholder="請輸入購卡時填寫的手機號" v-model="mobile" />
      </div>
      <div class="flexa flexsb box-1" style>
        <input
          type="text"
          maxlength="6"
          class="captcha-input"
          placeholder="請輸入動態驗證碼"
          v-model="captcha"
          ref="captcha"
        />
        <div class="flexa" style="margin-right: 16px;">
          <div class="getSMSCode" @click="getSMSCode" v-if="!isCounting">獲取驗證碼</div>
          <div class="p-999" style="margin-left: 16px;" v-else>{{count}}s後重新獲取</div>
          <!-- <span class="p-FA800A">59s</span>
          <span class="p-999">後可以重新獲取</span>-->
        </div>
      </div>
    </div>
    <div class="box-2" v-if="isCounting">驗證碼已發送到您的手機。請註意查收</div>
    <div class="flexaj">
      <el-button
        type="primary"
        class="p-fw p-f20 btn"
        style="width:305px;"
        @click="activate"
        :loading="isLoading"
      >查看</el-button>
    </div>
    <van-picker
      :columns="columns"
      :default-index="3"
      class="picker"
      :class="isPickerShow?'picker-active':''"
      show-toolbar
      title="區號"
      @cancel="onCancel"
      @confirm="onConfirm"
    />
    <div class="mask" v-if="isPickerShow" @click="isPickerShow=false"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Notify } from "vant";
import { mobileCode } from "../assets/mobileCode.json";
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import { getUrlValue, fakeMobile } from "@/utils/fun";
import { isiOS } from "@/utils/mobile";
export default {
  data() {
    return {
      status: 0,
      getHeight: "height: 100vh;",
      isLoading: false,
      count: 10,
      isCounting: "",
      mobileShow: "86 中國大陸",
      activateCode: "",
      type: "entity",
      isPickerShow: false,
      mobile: "",
      mobileCode: [],
      columns: [],
      mobileCodeSelected: "86",
      order_no: "",
      captcha: "",
      clock: null,
      isSafari: false
    };
  },
  methods: {
    async activate() {
      if (!this.activateCode && this.status !== "2" && this.type === "entity") {
        Toast.fail(`激活碼不能為空`);
        return false;
      }
      if (!this.mobileCodeSelected) {
        Toast.fail(`請選擇區號`);
        return false;
      }
      if (!this.mobile) {
        Toast.fail(`手機號碼不能為空`);
        return false;
      }
      if (!this.captcha) {
        Toast.fail(`驗證碼不能為空`);
        return false;
      }
      let obj1 = {
        order_no: this.order_no,
        mob_no: this.mobile,
        verify_code: this.captcha
      };
      let obj2 = {
        active_code: this.activateCode
      };
      let params = {};
      if (this.type === "entity") {
        params = Object.assign({}, obj1, obj2);
      } else {
        params = obj1;
      }
      this.isLoading = true;
      let res = await aPost2(api.cardActivate, params);
      if (res.data.errCode === "99999") {
        this.$router.push({
          name: "inquire-app",
          params: { order_no: this.order_no }
        });
      } else if (res.data.errCode === "88888") {
        this.captcha = "";
        clearInterval(this.clock);
        this.clock = null;
        this.isCounting = false;
        this.isLoading = false;
        Toast.fail(`${res.data.errMsg}`);
      } else if (res.data.errCode === "100809") {
        this.$refs.captcha.focus();
        this.captcha = "";
        this.isLoading = false;
        Toast.fail(`${res.data.errMsg}`);
      } else {
        this.isLoading = false;
        Toast.fail(`${res.data.errMsg}`);
      }
    },
    //倒計時
    startCounting() {
      this.count = 60;
      let that = this;
      that.isCounting = true;
      that.clock = setInterval(() => {
        if (that.count > 0) {
          that.count--;
        } else {
          clearInterval(that.clock);
          that.clock = null;
          that.isCounting = false;
        }
      }, 1000);
    },
    async getSMSCode() {
      if (!this.mobile) {
        Toast.fail("手機號碼不能為空");
        return false;
      }
      let params = {
        type: 88,
        phone:
          this.mobileCodeSelected === "86"
            ? this.mobile
            : this.mobileCodeSelected + "-" + this.mobile,
        email: this.email,
        gf_order_no: this.order_no
      };
      let res = await aPost2(api.getSMSCode, params);
      try {
        if (res) {
          if (res.data.errCode === "99999") {
            this.startCounting();
          } else if (res.data.errCode === "100810") {
            Toast.fail("操作過於頻繁，請稍後重試");
          } else if (res.data.errCode === "88888") {
            Toast.fail(`${res.data.errMsg}`);
          } else {
            Toast.fail(`${res.data.errMsg}`);
          }
        }
      } catch {}
    },
    onCancel() {
      this.isPickerShow = false;
    },
    onConfirm(value) {
      mobileCode.forEach(e => {
        let key = e.code + " " + e.area;
        if (value === key) {
          this.mobileCodeSelected = e.code;
        }
      });
      this.mobileShow = value;
      this.isPickerShow = false;
    },
    inquire() {
      this.$router.push({ name: "inquire-app" });
    },
    async getOrderStatus() {
      let res = await aPost2(api.queryStatus, { order_no: this.order_no });
      if (res.data.errCode === "99999") {
        this.status = res.data.retData.status;
        this.type = res.data.retData.card_type === "00" ? "entity" : "virtual";
        // if (this.status === "2") {
        //   sessionStorage.setItem("order_no", this.order_no);
        //   this.$router.push({
        //     name: "inquire-app",
        //     params: { order_no: this.order_no, type: this.type }
        //   });
        // }
      }
    }
  },
  mounted() {
    if (
      /Safari/.test(navigator.userAgent) &&
      !/Chrome/.test(navigator.userAgent)
    ) {
      var h = document.body.clientHeight;
      this.isSafari = true;
      localStorage.setItem("isSafari", 1);
    } else {
      localStorage.setItem("isSafari", 0);
    }
    this.mobileCode = mobileCode;
    mobileCode.forEach(e => {
      this.columns.push(e.code + " " + e.area);
    });
    if (this.$route.params.order_no || sessionStorage.getItem("order_no")) {
      this.order_no =
        this.$route.params.order_no || sessionStorage.getItem("order_no");
      sessionStorage.setItem("order_no", this.order_no);
      this.getOrderStatus();
    } else {
      Toast.fail("訂單號丟失，請重新打開此頁面！");
    }
  }
};
</script>

<style lang="scss" scoped>
.safari-class {
  height: 90vh !important;
}
.normal-class {
  height: 100vh;
}
.auth-app {
  font-size: 20px;
  background: #f6f5fa;
  /* height: 100vh; */
  position: relative;
  overflow: hidden;
  .mobile-input {
    flex-grow: 1;
    font-size: 20px;
  }
  .getSMSCode {
    padding: 6px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-left: 10px;
    cursor: pointer;
  }
  .mobile-picker {
    padding: 10px;
  }
  .picker {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    /* height: 400px; */
    margin-bottom: -3400px;
    transition: all 0.3s;
    z-index: 2;
    font-size: 14px !important;
  }
  /deep/ .van-field__control {
    font-size: 18px;
    height: 40px;
    line-height: 40px;
  }
  /deep/ .van-picker__confirm,
  /deep/ .van-picker__title,
  /deep/ .van-picker__cancel,
  /deep/ .van-picker-column__item {
    font-size: 20px;
  }
  /* /deep/ .van-picker__title {
    font-size: 20px;
  }
  /deep/ .van-picker__cancel {
    font-size: 20px;
  }
  /deep/ .van-picker-column__item {
    font-size: 20px;
  } */
  /* /deep/ .van-picker__columns{
    height: 370px !important;
  } */
  .picker-active {
    margin-bottom: 0;
  }
  input {
    padding: 10px;
    padding-right: 0;
  }
  /deep/ .mint-header {
    font-size: 22px;
    height: 60px;
    background: linear-gradient(to bottom, #37363b, #424244);
  }
  /deep/ .mint-header-title {
    height: 60px;
    line-height: 60px;
    font-weight: bold !important;
  }
  .account {
    padding: 20px;
    border-bottom: 1px solid #ccc;
    /* font-weight: bold; */
  }
  .input-box {
    background: #fff;
    padding: 20px;
    padding-bottom: 0;
    input {
      height: 30px;
      border: none;
    }
    .cvc2-input {
      width: 100%;
    }
    .box-1 {
      border-bottom: 1px solid #ccc;
      padding: 20px 0;
    }
    .captcha-input {
      width: 230px;
    }
  }
  .box-2 {
    color: #666;
    padding: 20px;
    background: #fff;
    border-bottom: 1px solid #ccc;
  }
  .btn {
    line-height: 30px;
    margin-top: 40px;
  }
}
</style>